<template>
  <div
    v-if="topNavComponent"
    :class="
      configInfo && configInfo.isMournMode
        ? ' home-index-gray layout-website'
        : 'layout-website'
    "
  >
    <!-- [鼠标跟随效果-2026-03-10] 仅PC端展示 -->
    <MouseFollower />
    <frame-top :top-nav-component="topNavComponent"></frame-top>
    <div class="layout-website-content">
      <router-view></router-view>
    </div>
    <frame-bottom
      :copyright-nav-component="copyrightNavComponent"
    ></frame-bottom>
  </div>
  <Error404 v-else-if="isNoneDomain" />
  <div v-else class="system-maintenance">
    <el-empty
      class="empty-content"
      :description="noContentTip"
      :image-size="300"
    >
      <template #image>
        <emptyIcon style="width: 300px; height: 200px"></emptyIcon>
      </template>
    </el-empty>
  </div>
  <button
    id="btn_smoothToTop"
    type="button"
    class="style-goto-top"
    :class="{ 'style-show': styleShowLaMby }"
    @click="handleSmoothToTopScroll"
  >
    <svg
      t="1693361300158"
      class="top-icon"
      viewBox="0 0 1024 1024"
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
      p-id="9670"
    >
      <path
        d="M542.293333 268.373333a42.666667 42.666667 0 0 0-14.08-8.96 42.666667 42.666667 0 0 0-32.426666 0 42.666667 42.666667 0 0 0-14.08 8.96l-170.666667 170.666667a42.666667 42.666667 0 1 0 60.586667 60.586667L469.333333 401.493333V896a42.666667 42.666667 0 0 0 85.333334 0V401.493333l97.706666 98.133334a42.666667 42.666667 0 0 0 60.586667 0 42.666667 42.666667 0 0 0 0-60.586667zM810.666667 85.333333H213.333333a42.666667 42.666667 0 0 0 0 85.333334h597.333334a42.666667 42.666667 0 0 0 0-85.333334z"
        p-id="9671"
        fill="#707070"
      ></path>
    </svg>
  </button>
</template>
<script setup>
// #region 引用
import {
  OwPageType,
  OwComponentType,
  OwTemplateStatus,
  ColumnType,
} from '@/configs/enums/website';
import {
  getConfigBasicInfoByDomain,
  getConfigFullInfo,
  getTemplateFullInfo,
  getColumnDetailById,
} from '@/apis/modules/auth/website/website-ssr';
import treeConverter from '@/utils/converter/tree-converter';
import {
  getColumnPageUrlForWebsite,
  // getColumnPageUrlNew,
} from '@/utils/business/website';
import { generateSorter } from '@/utils/common/sort-util';
import useSSRInitialStateStore from '@/stores/ssr-state';
import { useSSRContext } from '@/ssr/use-context';
import Error404 from '@/views/empty/error/CompError404.vue';
import FrameTop from './FrameTop.vue';
import FrameBottom from './FrameBottom.vue';
import emptyIcon from '../assets/images/troubleshooting-pana.svg';
// [鼠标跟随效果-2026-03-10]
import MouseFollower from '@/components/basic/MouseFollower.vue';

// #endregion

// #region props/emit

// #endregion

// #region 变量/常量

const ssrInitialState = useSSRInitialStateStore();
const route = useRoute();
const viewType = ref(null);
const previewId = ref(null);
const configInfo = ref({}); // 配置信息
const configPageList = ref([]); // 配置页面列表
const originalColumnList = ref([]); // 原始栏目列表
const columnList = ref([]); // 树形结构的栏目列表
const curMapColumnList = ref([]); // 当前位置的栏目列表
const curSiblingColumnInfo = ref([]); // 当前同级栏目信息
const columnId = ref(Number(route.params.columnId)); // 当前栏目id
const columnInfo = ref({}); // 当前栏目信息
const styleShowLaMby = ref(false); // 显示返回顶部按钮
const copyrightNavComponent = ref(null); // 底部导航组件
const topNavComponent = ref(null); // 顶部导航组件
const isNoneDomain = ref(false); // 是否无域名
const noContentTip = ref('您预览的模板未维护任何内容，请先去维护。'); // 无内容提示
const homeUrl = ref(null);

// 客户端数据恢复 - 必须在 useHead 之前执行，否则会覆盖 SSR 渲染的标题
if (!import.meta.env.SSR) {
  configInfo.value = ssrInitialState.data.current.configInfo;
  configPageList.value = ssrInitialState.data.current.configPageList;
  topNavComponent.value = ssrInitialState.data.current.topNavComponent;
  copyrightNavComponent.value =
    ssrInitialState.data.current.copyrightNavComponent;
  isNoneDomain.value = ssrInitialState.data.current.isNoneDomain;
  noContentTip.value = ssrInitialState.data.current.noContentTip;
  homeUrl.value = ssrInitialState.data.current.homeUrl;
  viewType.value = ssrInitialState.data.current.viewType;
  previewId.value = ssrInitialState.data.current.previewId;
  curMapColumnList.value = ssrInitialState.data.current.curMapColumnList;
  curSiblingColumnInfo.value = ssrInitialState.data.current.curSiblingColumnInfo;
  columnInfo.value = ssrInitialState.data.current.columnInfo;
}

// SEO Head 管理 - 在变量定义和数据恢复之后，使用 computed 响应式
// 此时 configInfo 已填充数据，computed 会正确计算
useHead({
  title: computed(() => configInfo.value?.homeTitle || ''),
  meta: [
    {
      name: 'keywords',
      content: computed(() => configInfo.value?.homeKeyword || ''),
    },
    {
      name: 'description',
      content: computed(() => configInfo.value?.homeDesc || ''),
    },
  ],
});

// #endregion

// #region 业务方法

/**
 * 处理当前位置栏目信息
 * @param curColumnId 当前栏目ID
 * @param previewId 预览ID
 */
const handleCurMapColumnList = (curColumnId) => {
  const curInfo = originalColumnList.value.find((x) => x.id === curColumnId);
  if (!curInfo) {
    return; // 如果找不到栏目信息，直接返回
  }
  if (curInfo.parentId) {
    handleCurMapColumnList(curInfo.parentId);
  }

  let hrefUrl = curInfo.hrefURL;
  if (curInfo.columnType === ColumnType.导航栏目) {
    const subColumnList = originalColumnList.value
      .filter((x) => x.parentId === curInfo.id)
      .sort(generateSorter('sortNum'));
    if (subColumnList.length > 0) {
      const subFirstColumn = subColumnList[0];
      hrefUrl = getColumnPageUrlForWebsite(
        subFirstColumn.columnType,
        subFirstColumn.id,
        subFirstColumn.hrefURL,
        configPageList.value.find((x) => x.columnId === subFirstColumn.id)?.id,
        viewType.value,
        previewId.value,
      );
    }
  }

  curMapColumnList.value.push({
    id: curInfo.id,
    title: curInfo.columnName,
    url: getColumnPageUrlForWebsite(
      curInfo.columnType,
      curInfo.id,
      hrefUrl,
      configPageList.value.find((x) => x.columnId === curInfo.id)?.id,
      viewType.value,
      previewId.value,
    ),
    parentId: curInfo.parentId,
  });
};

/**
 * 数据处理函数
 *
 * @param topNavComponent 顶部导航组件对象
 * @returns 无返回值
 */
const dataProcessing = (topNav) => {
  if (topNav.configData) {
    const configData = JSON.parse(topNav.configData);
    let list = []; // 定义新栏目列表
    // 处理栏目跳转链接
    configData.columnList.forEach((element) => {
      const newElement = { ...element }; // 创建新的对象
      newElement.hrefURL = getColumnPageUrlForWebsite(
        newElement.columnType,
        newElement.id,
        newElement.hrefURL,
        configPageList.value.find((x) => x.columnId === newElement.id)?.id,
        viewType.value,
        previewId.value,
      );
      list.push(newElement); // 将新对象推入列表
    });
    // 记录原始栏目列表
    originalColumnList.value = configData.columnList;
    // 树形结构处理
    list = treeConverter(list, {
      id: 'id',
      pid: 'parentId',
      label: 'columnName',
      sorter: ['sortNum'],
      disabled: (item) => item.columnName.indexOf('columnName') > -1,
    });
    // 存储树形结构的栏目列表
    configData.columnList = list;

    // 记录当前栏目id
    configData.activeIndex = route.params.columnId;

    // 处理左侧导航栏显示标记
    if (configData.navPageLeftArea && configData.navPageLeftArea.showNav) {
      topNav.isShowLeftNav = configData.navPageLeftArea.showNav;
      topNav.navPageLeftArea = configData.navPageLeftArea;
    }
    // 处理当前位置栏目信息
    if (columnId.value) {
      handleCurMapColumnList(columnId.value);
      // 当前一级栏目id
      const curFirstColumnInfo = curMapColumnList.value.find(
        (x) => !x.parentId,
      );
      if (curFirstColumnInfo) {
        curSiblingColumnInfo.value = configData.columnList.find(
          (x) => x.id === curFirstColumnInfo.id,
        );
      }
    }

    topNav.configData = JSON.stringify(configData);
  }
};

/**
 * 异步获取官网配置信息的完整信息
 *
 * @returns {Promise<void>} 无返回值
 */
async function fetchConfigFullInfo(host) {
  // 这里应该是一个实际的 API 请求
  // 重复刷新页面会重复请求
  if (route.path.includes('/undefined/')) {
    return;
  }

  if (route.path.startsWith('/template/')) {
    viewType.value = 'template';
  } else if (route.path.startsWith('/preview/')) {
    viewType.value = 'preview';
  } else {
    viewType.value = 'website';
  }

  // 官网/模板ID
  if (viewType.value === 'website') {
    const res = await getConfigBasicInfoByDomain.use({
      domainUrl: host,
    });
    if (res.code === '00000' && res.data) {
      previewId.value = res.data.id;
    } else {
      console.error('独立域名未绑定官网信息');
      isNoneDomain.value = true;
      return;
    }
  } else {
    previewId.value = route.params.id;
  }

  const apiUrl =
    viewType.value === 'template' ? getTemplateFullInfo : getConfigFullInfo;
  const apiData =
    viewType.value === 'template'
      ? { id: previewId.value }
      : { owConfigId: previewId.value };
  // 在服务器端渲染期间预取数据
  // 获取组件模板数据
  const res = await apiUrl.use(apiData);

  if (res.code === '00000' && res.data) {
    // 文件地址手动替换一下
    if (viewType.value === 'template') {
      res.data.templatePageList.forEach((element) => {
        if (element.componentList.length > 0) {
          element.componentList.forEach((item) => {
            const curItem = item;
            if (curItem.configData) {
              curItem.configData = curItem.configData.replaceAll(
                '/upload/',
                `${import.meta.env.VITE_API_URL}/upload/`,
              );
            }

            curItem.effectCoverImg = `${
              import.meta.env.VITE_API_URL + curItem.effectCoverImg
            }?v=${curItem.effectCoverImg}`;
            item = curItem;
          });
        }
      });
      // 预览调用需要单独处理
      const { templateBasicInfo } = res.data;
      const { templatePageList } = res.data;

      // 成功
      configInfo.value = {
        homeTitle: templateBasicInfo.templateName,
        homeKeyword: templateBasicInfo.templateName,
        homeDesc: templateBasicInfo.templateName,
      };
      configPageList.value = templatePageList;
    } else {
      if (
        viewType.value === 'website' &&
        res.data.configBasicInfo.status === OwTemplateStatus.待发布
      ) {
        console.error('站点未发布');
        noContentTip.value = '官网正在维护升级中，给您带来不便，敬请谅解。';
        return;
      }

      // 成功
      res.data.configPageList.forEach((element) => {
        if (element.componentList.length > 0) {
          element.componentList.forEach((item) => {
            const curItem = item;
            if (curItem.configData) {
              curItem.configData = curItem.configData.replaceAll(
                '/upload/',
                `${import.meta.env.VITE_API_URL}/upload/`,
              );
            }

            curItem.effectCoverImg = `${
              import.meta.env.VITE_API_URL + curItem.effectCoverImg
            }?v=${curItem.effectCoverImg}`;
            item = curItem;
          });
        }
      });
      configInfo.value = res.data.configBasicInfo;
      configPageList.value = res.data.configPageList;
    }

    /**
     * 版权区域
     */
    copyrightNavComponent.value = configPageList.value
      .find((f) => f.pageType === OwPageType.首页)
      .componentList.find(
        (f) => f.componentType === OwComponentType.版权区组件,
      );

    /**
     * 导航栏区域
     */

    topNavComponent.value = configPageList.value
      .find((f) => f.pageType === OwPageType.首页)
      .componentList.find(
        (f) => f.componentType === OwComponentType.顶部导航栏组件,
      );
    if (topNavComponent.value) {
      topNavComponent.value.fromType = 3;
      dataProcessing(topNavComponent.value);
    }

    // 首页url
    homeUrl.value = getColumnPageUrlForWebsite(
      ColumnType.链接栏目,
      null,
      '/',
      null,
      viewType.value,
      previewId.value,
    );
  }
}

/**
 * 异步函数，用于获取栏目信息详情
 *
 * @returns 无返回值
 */
async function fetchColumn() {
  // 这里应该是一个实际的 API 请求
  if (route.params.columnId) {
    const content = await getColumnDetailById.use({ columnId: columnId.value });
    if (content.code === '00000' && content.data) {
      columnInfo.value = content.data;
    }
  }
}

/**
 * 在服务端获取数据
 */
onServerPrefetch(async () => {
  const ssrContext = useSSRContext();
  // 获取配置信息
  await fetchConfigFullInfo(ssrContext.initialState.data.host);
  // 路由参数中有栏目信息就获取栏目数据
  await fetchColumn();

  // 将数据设置到initialState（后续的内容页都从这里获取数据）
  ssrContext.initialState.data.current = {
    configInfo: configInfo.value,
    configPageList: configPageList.value,
    topNavComponent: topNavComponent.value,
    columnList: columnList.value,
    curMapColumnList: curMapColumnList.value,
    curSiblingColumnInfo: curSiblingColumnInfo.value,
    copyrightNavComponent: copyrightNavComponent.value,
    viewType: viewType.value,
    previewId: route.params.id, // 模板预览时的id，预览官网是的模板
    columnId: route.params.columnId, // 栏目id，用于判断选中栏目
    columnInfo: columnInfo.value,
    isNoneDomain: isNoneDomain.value,
    noContentTip: noContentTip.value,
    homeUrl: homeUrl.value,
  };
  // SEO 已在组件 setup 顶层通过 useHead + computed 处理
});

/** *
 * 定义一个防抖函数
 */
const debounce = (fn, delay = 500) => {
  let timer = null;
  return function (...args) {
    if (timer) clearTimeout(timer);
    timer = setTimeout(() => {
      fn.apply(this, args);
    }, delay);
  };
};
/**
 * [优化-2026-03-12] ease-out-quart 缓动函数
 * 特点：快速启动，缓慢停止，手感最丝滑
 */
const easeOutQuart = (t) => 1 - Math.pow(1 - t, 4);

/**
 * [优化-2026-03-12] 平滑滚动到顶部
 * 使用 requestAnimationFrame + ease-out-quart 缓动曲线
 * 根据滚动距离动态计算时长（距离越长，时间越长，但有上限）
 */
const smoothScrollToTop = (element, duration = 800) => {
  const start = element.scrollTop;
  const startTime = performance.now();

  const scroll = (currentTime) => {
    const elapsed = currentTime - startTime;
    const progress = Math.min(elapsed / duration, 1);
    const easedProgress = easeOutQuart(progress);

    element.scrollTop = start * (1 - easedProgress);

    if (progress < 1) {
      requestAnimationFrame(scroll);
    }
  };

  requestAnimationFrame(scroll);
};

/**
 * 滑动方法
 * [优化-2026-03-12] 使用自定义动画替代原生 smooth
 */
const scrollToTop = () => {
  // PC端：documentElement 或 body
  const documentScrollTop = document.documentElement.scrollTop || document.body.scrollTop;
  // 移动端：.layout-website 容器
  const scrollContainer = document.querySelector('.layout-website');
  const containerScrollTop = scrollContainer ? scrollContainer.scrollTop : 0;

  // 取两者中的较大值判断滚动位置
  const maxScrollTop = Math.max(documentScrollTop, containerScrollTop);

  if (maxScrollTop > 0) {
    // 根据滚动距离动态计算时长（基础500ms + 距离/10，上限1200ms）
    const duration = Math.min(500 + maxScrollTop / 10, 1200);

    if (containerScrollTop > 0 && scrollContainer) {
      smoothScrollToTop(scrollContainer, duration);
    }
    if (documentScrollTop > 0) {
      smoothScrollToTop(document.documentElement, duration);
    }
  }
};

/**
 * 判断是否显示回到顶部按钮
 * [优化-2026-03-12] 兼容所有滚动场景
 */
const isElemVisible = (el) => {
  // 尝试多种方式获取滚动位置，兼容不同环境
  const scrollContainer = document.querySelector('.layout-website');
  const containerScrollTop = scrollContainer ? scrollContainer.scrollTop : 0;
  const documentScrollTop = document.documentElement.scrollTop || document.body.scrollTop || 0;
  const windowScrollY = typeof window !== 'undefined' ? window.scrollY : 0;

  // 取所有值中的最大值，确保在任何环境下都能检测到滚动
  const scrollTop = Math.max(containerScrollTop, documentScrollTop, windowScrollY);

  // 滚动超过 300px 显示按钮
  return scrollTop > 300;
};

/**
 * 平滑滚动到页面顶部
 * [Bug修复-2026-03-09] 回滚：删除 ssrInitialState.setDataBackTop(false)
 */
const handleSmoothToTopScroll = () => {
  scrollToTop();
  // smoothToTop.classList.remove('style-show');
  styleShowLaMby.value = false;
  // [Bug修复-2026-03-09] 同步重置导航栏背景透明度
  ssrInitialState.setDataBackTop(false);
};

/**
 * 处理滚动效果
 */
const handleScroll = (evt) => {
  const smoothToTop = document.getElementById('btn_smoothToTop');

  if (isElemVisible(smoothToTop)) {
    styleShowLaMby.value = true;
    ssrInitialState.setDataBackTop(true);
  } else {
    styleShowLaMby.value = false;
    ssrInitialState.setDataBackTop(false);
  }
};

/**
 * 设置网站图标
 */
const setIconFavicon = (iconUrl) => {
  // 移除现有的 favicon
  const existingLinks = document.querySelectorAll('link[rel*="icon"]');
  existingLinks.forEach((link) => {
    document.head.removeChild(link);
  });
  // 创建新的 favicon
  const link = document.createElement('link');
  link.type = 'image/x-icon';
  link.rel = 'shortcut icon';
  link.href = iconUrl;
  document.head.appendChild(link);
};

if (!import.meta.env.SSR) {
  // 设置网站图标
  if (configInfo.value?.favicon) {
    setIconFavicon(import.meta.env.VITE_API_URL + configInfo.value.favicon);
  }
}

/**
 * [修复-2026-03-12] 使用 onMounted 确保 DOM 渲染完成后再绑定滚动事件
 * 解决浏览器模拟移动端模式下按钮不显示的问题
 */
onMounted(() => {
  if (import.meta.env.SSR) return;

  if (typeof window !== 'undefined') {
    window.addEventListener('scroll', debounce(handleScroll, 100), { passive: true });
  }
  if (document) {
    document.addEventListener('scroll', debounce(handleScroll, 100), { passive: true });
    document.addEventListener('touchmove', debounce(handleScroll, 100), { passive: true });
  }
  // 监听容器滚动（移动端）
  const scrollContainer = document.querySelector('.layout-website');
  if (scrollContainer) {
    scrollContainer.addEventListener('scroll', debounce(handleScroll, 100), { passive: true });
  }
});

// #endregion
</script>

<style scoped lang="scss">
// PC端样式 (>= 1180px)
@media screen and (min-width: 1180px) {
  .layout-website {
    display: flex;
    flex-direction: column;
    height: 100vh;

    .layout-website-content {
      flex-grow: 1;
    }
  }

  .home-index-gray {
    filter: progid:DXImageTransform.Microsoft.BasicImage(graysale=1);
    filter: grayscale(100%);
  }

  /* stylelint-disable-next-line selector-class-pattern */
  .style-goto-top {
    position: fixed;
    right: 80px;
    bottom: 80px;
    display: inline-block;
    align-items: center;
    justify-content: center;
    width: 56px;
    min-width: 56px !important;
    height: 56px;
    min-height: 56px !important;
    font-size: 26px;
    color: #b1b3b8;
    text-align: center;
    cursor: pointer;
    visibility: hidden;
    background-color: rgba(255, 255, 255, 0.85);
    backdrop-filter: blur(10px);
    -webkit-backdrop-filter: blur(10px);
    border: none;
    border-radius: 100%;
    box-shadow: 0 4px 20px rgb(0 0 0 / 15%);
    opacity: 0;
    transition: all 0.3s;

    .top-icon {
      justify-content: center;
      width: 32px;
      height: 32px;
    }
    
    &:hover {
      transform: scale(1.1);
      box-shadow: 0 6px 24px rgb(0 0 0 / 20%);
    }
  }

  .style-goto-top.style-show {
    visibility: visible;
    opacity: 1;
  }

  .system-maintenance {
    display: flex;
    align-items: center;
    justify-content: center;
    height: 100vh;
  }
}

// 移动端样式 (< 1180px)
@media screen and (max-width: 1179px) {
  .layout-website {
    display: flex;
    flex-direction: column;
    height: 100vh;
    overflow-x: hidden;
    background-color: #fff;

    .layout-website-content {
      flex-grow: 1;
    }
  }

  .home-index-gray {
    filter: progid:DXImageTransform.Microsoft.BasicImage(graysale=1);
    filter: grayscale(100%);
  }

  .style-goto-top {
    position: fixed;
    right: 4vw;
    bottom: 4vw;
    display: inline-block;
    align-items: center;
    justify-content: center;
    width: 14vw;
    min-width: 14vw !important;
    height: 14vw;
    min-height: 14vw !important;
    font-size: 8vw;
    color: #b1b3b8;
    text-align: center;
    cursor: pointer;
    visibility: hidden;
    background-color: rgba(255, 255, 255, 0.85);
    backdrop-filter: blur(10px);
    -webkit-backdrop-filter: blur(10px);
    border: none;
    border-radius: 100%;
    box-shadow: 0 2px 16px rgb(0 0 0 / 15%);
    opacity: 0;
    transition: all 0.3s;

    .top-icon {
      justify-content: center;
      width: 8vw;
      height: 8vw;
    }
  }

  .style-goto-top.style-show {
    visibility: visible;
    opacity: 1;
  }

  .system-maintenance {
    display: flex;
    align-items: center;
    justify-content: center;
    height: 100vh;
  }
}

.empty-content {
  :deep(.el-empty__description > p) {
    font-size: 18px;
  }
}
</style>
